export default __webpack_public_path__ + "static/media/Header.0641598d.svg";